import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import Login from './pages/Login';
import Dashboard from './components/Dashboard';
import DashboardHome from './pages/DashboardHome';
import Leads from './pages/Leads';
import Conversations from './pages/Conversations';
import Analytics from './pages/Analytics';
import CustomerUpload from './pages/CustomerUpload';
import Simulator from './pages/Simulator';
import Settings from './pages/Settings';
import MyQueue from './pages/MyQueue';
import Reports from './pages/Reports';
import SendModeTest from './pages/SendModeTest';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" />} />
        <Route path="dashboard" element={<DashboardHome />} />
        <Route path="my-queue" element={<MyQueue />} />
        <Route path="leads" element={<Leads />} />
        <Route path="conversations" element={<Conversations />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="upload" element={<CustomerUpload />} />
        <Route path="simulator" element={<Simulator />} />
        <Route path="reports" element={<Reports />} />
        <Route path="sendmode-test" element={<SendModeTest />} />
        <Route path="settings" element={<Settings />} />
        <Route path="profile" element={<div>Profile Page</div>} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

export default App;
